export default "__VITE_ASSET__ef88fd20__"